import axios from "axios";
import Swal from "sweetalert2";
import {
  baseUrl,
  defaultUpdateErrorMessage,
  objectifyForDropdown,
} from "../util";

export const getEconomicSupplierListBulk = ({
  businessId,
  objectId,
  objects,
  setObjects = function () {
    return;
  },
  setCategorizedData = function () {
    return;
  },
  category,
  facilityId,
  year,
  allocatedYear,
  period,
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/supplier-economic-bulk",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      year: year,
      period: period,
      allocatedYear: allocatedYear,
    },
  };

  axios(config)
    .then(function (response) {
      if (category && facilityId) {
        setCategorizedData(
          response.data.data.filter((data) => {
            return (
              data.facility_id === facilityId && data.category === category
            );
          })
        );
      }

      setObjects(
        response.data.data.map((data) => {
          data.facility = objectifyForDropdown(data.facility);
          data.category = objectifyForDropdown(data.category);
          data.subcategory = objectifyForDropdown(data.subcategory);
          data.emission_factor = objectifyForDropdown(data.emission_factor);
          data.is_manuel = data.is_manuel ? "Yes" : "No";
          return data;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
      // setLoading(false)
      // Swal.fire({
      //   title: errorTranslate(),
      //   icon: 'error',
      //   text: error,
      //   confirmButtonColor: '#a9c1b4',
      //   // width: 600,
      //   // padding: '3em',
      //   color: '#476355',
      //   background: '#f1f8ef',
      // })
    });
};

export const updateEconomicSupplierBulk = ({
  businessId,
  objectsToUpdate,
  objects,
  setObjects = function () {
    return;
  },
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify(objectsToUpdate);

  var config = {
    method: "put",
    url: baseUrl + "/api/business/" + businessId + "/supplier-economic-bulk",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };

  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setObjects(
        objects.map((supply) => {
          const updatedItem = response.data.updated_instances.find(
            (id) => id === supply.id
          );
          if (updatedItem) {
            const updatedData = objectsToUpdate.find(
              (item) => item.id === updatedItem
            );
            if (updatedData) {
              updatedData.facility = objectifyForDropdown(updatedData.facility);
              updatedData.category = objectifyForDropdown(updatedData.category);
              updatedData.subcategory = objectifyForDropdown(
                updatedData.subcategory
              );
              updatedData.emission_factor = objectifyForDropdown(
                updatedData.emission_factor
              );
              updatedData.is_manuel = updatedData.is_manuel ? "Yes" : "No";
              return { ...supply, ...updatedData };
            }
          }
          return supply;
        })
      );

      if (use_swal)
        Swal.fire({
          title: "Success!",
          text: `Updated ${response.data.updated_count} items successfully.`,
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });

      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);

      if (loading) setLoading("failed");

      if (use_swal)
        Swal.fire({
          title: "Error!",
          text: defaultUpdateErrorMessage,
          icon: "error",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });

      setErrorMessage(error.response.data);
    });
};

export const getEconomicSupplierListBulkByYear = ({
  businessId,
  setObjectsIsSelected = function () {
    return;
  },
  setObjects = function () {
    return;
  },
  setCategorizedData = function () {
    return;
  },
  setChosenYear = function () {
    return;
  },
  setYearEcoApi = function () {
    return;
  },
  setAccountingPeriod = function () {
    return;
  },
  category,
  facilityId,
  allocatedYear,
  isEdit,
}) => {
  var config = {
    method: "get",
    url:
      baseUrl +
      "/api/business/" +
      businessId +
      "/supplier-economic-bulk-by-year",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      allocated_year: allocatedYear,
    },
  };

  axios(config)
    .then(function (response) {
      if (category && facilityId) {
        setCategorizedData(
          response.data.data_is_selected.filter((data) => {
            return (
              data.facility_id === facilityId && data.category === category
            );
          })
        );
      }

      setObjects(
        response.data.data.map((data) => {
          data.facility = objectifyForDropdown(data.facility);
          data.category = objectifyForDropdown(data.category);
          data.subcategory = objectifyForDropdown(data.subcategory);
          data.emission_factor = objectifyForDropdown(data.emission_factor);
          data.is_manuel = data.is_manuel ? "Yes" : "No";
          return data;
        })
      );

      const processedSelectedObjects = response.data.data_is_selected.map(
        (data) => {
          data.facility = objectifyForDropdown(data.facility);
          data.category = objectifyForDropdown(data.category);
          data.subcategory = objectifyForDropdown(data.subcategory);
          data.emission_factor = objectifyForDropdown(data.emission_factor);
          data.is_manuel = data.is_manuel ? "Yes" : "No";
          return data;
        }
      );

      setObjectsIsSelected(processedSelectedObjects);

      // Set chosenYear based on year in the first item (if not null)
      if (
        processedSelectedObjects.length > 0 &&
        processedSelectedObjects[0].year &&
        isEdit
      ) {
        setChosenYear(processedSelectedObjects[0].year);
      }

      if (
        processedSelectedObjects.length > 0 &&
        processedSelectedObjects[0].period &&
        isEdit
      ) {
        setAccountingPeriod(processedSelectedObjects[0].period);
      }

      // Set yearEcoApi based on year_api (if not null)
      if (
        processedSelectedObjects.length > 0 &&
        processedSelectedObjects[0].year_api &&
        isEdit
      ) {
        setYearEcoApi(processedSelectedObjects[0].year_api);
      } else if (processedSelectedObjects.length > 0 && isEdit) {
        // If year_api is null, convert the year format
        const yearMatch =
          processedSelectedObjects[0].year.match(/(\d{4})\/(\d{4})/);
        if (yearMatch) {
          const startYear = yearMatch[1];
          const endYear = yearMatch[2];
          setYearEcoApi(`${startYear}_6_${endYear}`);
        }
      }
    })
    .catch(function (error) {
      console.log(error);
      // setLoading(false)
      // Swal.fire({
      //   title: errorTranslate(),
      //   icon: 'error',
      //   text: error,
      //   confirmButtonColor: '#a9c1b4',
      //   // width: 600,
      //   // padding: '3em',
      //   color: '#476355',
      //   background: '#f1f8ef',
      // })
    });
};
